export class LoginCookie {
  constructor(Cookie) {
    // Sets cookie just one time after login then destroys it and sets antoher- For Analytics
    if ($('#msQMyAccountNavWrapper').hasClass('c-login-box__loggedin')) {
      if (Cookie.get('logged-cookie') == "1") {

      } else {
        if (Cookie.get('just-loggedin-cookie') != null) {
          if ($('#just-loggedin-span')) {
            Cookie.delete('just-loggedin-cookie');
            Cookie.set('logged-cookie', 1, 1);
          }
        } else {
          Cookie.set('just-loggedin-cookie', 1, 1);
        }
      }
    } else {
      Cookie.delete('just-loggedin-cookie');
      Cookie.delete('logged-cookie');
    }
  }
}
